module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-tabletPro-es.dd1e7ebb.png";